import { useEffect } from "react";
import SelfUnlock from "../preAuth/selfUnlock";
import SelfUnlockOTP from "../preAuth/selfunlock-otp";
import { useTranslation } from "react-i18next";

export default function SelfUnlockMain({
  currentStep,
  setCurrentStep,
  data,
  setData,
}) {

  useEffect(() => {
    setCurrentStep(0)
   }, []);

  const { t } = useTranslation();
  const steps = [
    {
      title: t("common.details", {
        defaultValue: "Details",
      }),
    },
    {
      title: t("common.verify_pin", {
        defaultValue: "Verify PIN",
      }),
    },
    {
      title: t("common.complete", {
        defaultValue: "Complete",
      }),
    },
  ];

  return (
    <>
      <div>
        {/* <Stepper
          currentStep={currentStep}
          items={steps}
          setCurrentStep={setCurrentStep}
        ></Stepper> */}
        <div>
          {/* <h5 className="mb-2 " align="left">
            {t("pages.login.self_unlock", {
              defaultValue: "Self Unlock",
            })}
          </h5> */}
          <p
            className="secondary_txt_color_two"
            style={{ fontSize: "14px" }}
            align="left"
          >
            {t("pages.login.self_unlock_desc", {
              defaultValue: "Unlock your account quickly and securely with our Self Unlock feature.",
            })}
          </p>
        </div>
        {currentStep == 0 && (
          <SelfUnlock
            data={data}
            setData={setData}
            setCurrentStep={setCurrentStep}
          ></SelfUnlock>
        )}
        {currentStep === 1 && (
          <SelfUnlockOTP
            data={data}
            setData={setData}
            setCurrentStep={setCurrentStep}
          ></SelfUnlockOTP>
        )}
      </div>
    </>
  );
}
